import querystring from 'query-string';
import {
    fetches,
    generateFetchOpts,
    getTestQueryString,
    generateFetchOptsGetter
} from 'api/client';
import { POST } from 'api/common';
import * as clientErrTypes from 'config/clientErrorTypes';
import { CHECK_POINT_IS_LOCKED } from 'apiHandler/point';

/**
 * @description https://app.clickup.com/t/866afp4a9
 * @example  GET:`/promotions/points/pools/${pointPoolUuid}`
 * @method getPointPoolInfoByClientApi 取得點數池 Info ( client 流程 )
 * @param   {string} pointPoolUuid 點數池 uuid
 * @return  {promise}
 */
export const getPointPoolInfoByClientApi = pointPoolUuid => {
    return fetches(`/promotions/points/pools/${pointPoolUuid}`, generateFetchOpts(), {
        dataKeys: 'data'
    });
};

/**
 * @description https://app.clickup.com/t/866a8k3xc
 * @example  GET:`/promotions/members/${login}/point/pools/${pointPoolUuid}/histories/${loginType}`
 * @method getHistoriesByPointPoolMemberApi 取得 member 在特定點數池的點數歷程清單 Api
 * @param   {string} loginMethod 登入方式
 * @param   {string} pointPoolUuid 點數池 uuid
 * @param   {string} perPage 每頁幾筆
 * @param   {string} page 第幾頁
 * @return  {promise}
 */
export const getHistoriesByPointPoolMemberApi = ({ loginMethod, pointPoolUuid, perPage, page }) => {
    const qs = querystring.stringify({ page, perPage });

    return fetches(
        `/promotions/members/point/pools/${pointPoolUuid}/histories/${loginMethod}${
            Boolean(qs) ? `?${qs}` : ``
        }`,
        generateFetchOptsGetter(),
        { passPayload: true, dataKeys: 'data' }
    );
};

/**
 * @description https://app.clickup.com/t/866a8k4f4
 * @example  GET:`/promotions/members/point/pools/${pointPoolUuid}/${loginType}`
 * @method getMemberPointTotalByMemberApi member 在特定點數池的當前點數資料
 * @param   {string} loginType 登入方式 (facebook, line, enterprise...etc)
 * @param   {string} pointPoolUuid 點數池 uuid
 * @return  {promise}
 */

export const getMemberPointTotalByMemberApi = ({ pointPoolUuid, loginType }) => {
    const testQs = getTestQueryString();
    const qs = testQs ? `?${querystring.stringify(testQs)}` : '';
    return fetches(
        `/promotions/members/point/pools/${pointPoolUuid}/${loginType}${qs}`,
        generateFetchOptsGetter(),
        {
            dataKeys: 'data',
            throwErrConfigs: {
                [clientErrTypes.POINT_IS_LOCKED]: CHECK_POINT_IS_LOCKED
            }
        }
    );
};

/**
 * 活動參加限制扣點 api https://app.clickup.com/t/866a8k3nj
 * @param   {string} promoUuid promoUuid
 * @param   {string} entriesUuid entriesUuid
 * @return  {promise}
 */

export const deductPointByPromo = ({ promoUUID, currentEntryUUID }) => {
    return fetches(
        `/promotions/${promoUUID}/entries/${currentEntryUUID}/member/points/cost`,
        generateFetchOptsGetter({ method: POST }),
        {
            dataKeys: 'data'
        }
    );
};

/**
 * @description https://app.clickup.com/t/866a8k3zg
 * @example  GET:`/promotions/${promoUuid}/member/points`
 * @method getMemberPointTotalByPromo 取得 member 在特定活動中獲得的點數加總 api
 * @param   {string} promoUuid 活動 Uuid
 * @return  {promise}
 */
export const getMemberPointTotalByPromo = promoUuid => {
    return fetches(`/promotions/${promoUuid}/member/points`, generateFetchOptsGetter(), {
        dataKeys: 'data'
    });
};

/**
 * @method getPromoPointPoolInfosApi 取得活動使用的點數池清單
 * @param  {string} promoUUID 活動 Uuid
 * @return  {promise}
 */
export function getPromoPointPoolInfosApi(promoUUID) {
    return fetches(`/promotions/${promoUUID}/points/pools`, generateFetchOpts(), {
        dataKeys: 'data',
        throwErrConfigs: { [clientErrTypes.GET_API_ERROR]: r => r.httpStatus !== 200 }
    });
}
